<template>
  <div class="main-chapter1">
    <div class="right-info">
      Приложение 1<br>
      к Правилам оказания<br>
      инжиниринговых<br>
      услуг в сфере архитектурной,<br>
      градостроительной и<br>
      строительной деятельности<br>
      <br>
      Форма
    </div>
    <div class="chapter-title">Форма 1. Титульный лист журнала технического надзора</div>
    <n-items>
      <n-input title="Наименование объекта строительства" v-bind="$form.input('title')" />
      <n-input title="Адрес объекта " v-bind="$form.input('address')" />
      <n-input title="Полная сметная стоимость строительства объекта" v-bind="$form.input('totalCost')" />
      <n-input title="Заказчик" v-bind="$form.input('customer')" />
      <n-input title="Генеральный проектировщик (проектировщик)" v-bind="$form.input('projector')" />
      <n-input title="Генеральный подрядчик (подрядчик) " v-bind="$form.input('contractor')" />
      <n-input title="Технический надзор " v-bind="$form.input('tech')" />
      <n-datepicker title="Журнал начат" v-bind="$form.input('startedAt')" inline />
      <n-datepicker title="Журнал окончен" v-bind="$form.input('endedAt')" inline /><br />
      <n-input title="Руководитель организации технического надзора" v-bind="$form.input('supervisorTech')" />
      <n-input title="Руководитель заказчика " v-bind="$form.input('supervisorCustomer')" />
      <n-button color="success" @click="submit">Сохранить</n-button>
    </n-items>
    <n-loader :loading="$var('load')" />
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
  },
  data: () => ({
    subcontractors: [
      { name: '', bin: '', works: '', },
    ],
    columns: [
      { name: 'name', title: 'Наименование', },
      { name: 'bin', title: 'БИН', },
      { name: 'works', title: 'Работы', },
    ],
    columnsRecords: [
      { name: 'date', title: 'Дата', },
      { name: 'record', title: 'Пояснение', },
    ],
  }),
  created() {
    this.$form.init({
      ...this.journal.data,
    })
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, 'tech', this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
